import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { EditableTitle } from '@/shared/ui';

type Props = {
  name: string;
  onUpdateName?: (name: string) => void;
  disabled?: boolean;
};

export const EditableKnowledgeSetTitle: FC<Props> = ({ name, onUpdateName, disabled }) => {
  const { t } = useTranslation('knowledgeSets');

  return (
    <EditableTitle
      value={name || t('newKnowledgeSet')}
      label={t('renameKnowledgeSet')}
      placeholder={t('newKnowledgeSetPlaceholder')}
      onSave={onUpdateName}
      disabled={disabled}
    />
  );
};
